import { connect } from 'react-redux'
import { fetchLines, receiveLines, fetchRestrooms, fetchRestroomsSample, receiveRestrooms } from '../actions'
import { showAlert } from '../utils/Alert'
import Restroom from '../components/restroom/Restroom'

const mapStateToProps = (state, _props) => {
  const { lines } = state.stationReducer
  const { restrooms } = state.restroomReducer

  return {
    lines,
    restrooms,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchLines: async () => {
      try {
        const payload = await fetchLines()
        dispatch(receiveLines(payload))
      } catch (error) {
        showAlert('トイレ混雑度情報が取得できませんでした（001）')
      }
    },
    fetchRestrooms: async () => {
      try {
        const response = await fetchRestrooms()
        if (response.status == 200) {
          dispatch(receiveRestrooms(response.data))
        } else {
          throw `Vacan API response error. status code ${response.status}`
        }
      } catch (error) {
        showAlert('トイレ混雑度情報が取得できませんでした（002）')
      }
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Restroom)
